import axios from 'axios'
const API_BASE_URL = (window as any).env.REACT_APP_DEMO_BACKEND_URL

export const paymentSessionRemover = async () => {
    const sessionId = sessionStorage.getItem('paymentSessionId')

    if (!sessionId) {
        console.warn('No session ID found')
        return
    }

    try {
        await axios.post(API_BASE_URL + '/payment/session/' + sessionId + '/remove')
        console.info('Payment session removed successfully')
    } catch (error) {
        console.error('Error removing payment session', error)
    }
}
